var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tracking-scans"},_vm._l((_vm.scans),function(scan,idx){return _c('TrackingScanItem',{key:scan.scanTime + scan.status,attrs:{"scan":scan,"isCurrent":idx === 0}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }